export const portalEn = {
  'portal.title': 'The Portal',
  'portal.seoDescription': 'A turn-based boss battle using SRD 5.2.1 rules, played as painted miniatures on a tabletop. A free account is needed. Share the table link with friends who have an account.',
  'portal.about': 'A rift is tearing open above an ancient altar, and the Riftmaw is climbing through. Lead a party of four across a tabletop battlefield, one turn at a time: a ready-made level 7 fighter (you), Tuck the dog, and Wren and Sideguard Brann from Montkelian. Slay the Riftmaw, or seal the rift before round 10. Pieces move square by square, and friends with an account can join your table from its link. New, and the fight is not balanced yet.',
  'portal.start': 'Start a battle',
  'portal.startOver': 'Back to the start',
  'portal.signinBody': 'Sign in to play. Your hero joins the party at the table.',
  'portal.signinCta': 'Sign in to play',
  'portal.missingTitle': 'No such table',
  'portal.missingBody': 'That table link does not lead to a battle. It may have ended, or the code may be mistyped.',
  'portal.errorTitle': 'The table is out of reach',
  'portal.errorBody': 'The battle could not be reached just now. Try again in a moment.',
  'portal.offlineBody': 'The Portal is not available on this site yet.',
  'portal.networkTrouble': 'Could not reach the table. Try again.',

  'portal.objective.kicker': 'The Arcane Summoning',
  'portal.objective.title': 'Slay the Riftmaw or seal the rift',
  'portal.round': 'Round {n} of {of}',
  'portal.condition.frightened': 'Frightened',
  'portal.condition.restrained': 'Restrained',
  'portal.condition.prone': 'Prone',
  'portal.condition.unconscious': 'Unconscious',
  'portal.condition.dead': 'Dead',
  'portal.condition.dodging': 'Dodging',
  'portal.condition.disengaged': 'Disengaged',
  'portal.condition.stable': 'Stable',
  'portal.roll.nat20': 'Natural 20',
  'portal.roll.nat1': 'Natural 1',
  'srd.gallery': 'SRD 5.2.1 HUD pieces',
  'srd.prof': 'Prof', 'srd.abilities': 'Abilities', 'srd.sheet': 'Character sheet', 'srd.proficientSave': 'Proficient saving throw',
  'srd.level': 'Lv {n}', 'srd.more': 'Show the sheet', 'srd.less': 'Hide the sheet', 'srd.gold': '{n} gp',
  'srd.ability.str': 'Strength', 'srd.ability.dex': 'Dexterity', 'srd.ability.con': 'Constitution', 'srd.ability.int': 'Intelligence', 'srd.ability.wis': 'Wisdom', 'srd.ability.cha': 'Charisma',
  'srd.roll.normal': 'd20', 'srd.roll.advantage': 'd20 with advantage', 'srd.roll.disadvantage': 'd20 with disadvantage',
  'srd.result.resist': 'Resist', 'srd.result.vulnerable': 'Vulnerable', 'srd.result.immune': 'Immune',
  'srd.rest.short': 'Short rest', 'srd.rest.long': 'Long rest',
  'srd.action.attack': 'Attack', 'srd.action.dash': 'Dash', 'srd.action.dodge': 'Dodge', 'srd.action.disengage': 'Disengage', 'srd.action.help': 'Help', 'srd.action.hide': 'Hide', 'srd.action.ready': 'Ready', 'srd.action.useObject': 'Use Object', 'srd.action.cast': 'Cast',
  'srd.damage.bludgeoning': 'Bludgeoning', 'srd.damage.piercing': 'Piercing', 'srd.damage.slashing': 'Slashing', 'srd.damage.fire': 'Fire', 'srd.damage.cold': 'Cold', 'srd.damage.lightning': 'Lightning', 'srd.damage.acid': 'Acid', 'srd.damage.poison': 'Poison', 'srd.damage.necrotic': 'Necrotic', 'srd.damage.radiant': 'Radiant', 'srd.damage.psychic': 'Psychic', 'srd.damage.force': 'Force', 'srd.damage.thunder': 'Thunder',
  'portal.turn.yours': '{name}, your move',
  'portal.turn.foes': 'The foes act',
  'portal.rift': 'Rift opening: {n} of {of}',
  'portal.seals': 'Seals set: {n} of {of}',
  'portal.riftLabel': 'Rift opening',
  'portal.sealsLabel': 'Seals set',
  'portal.counter': '{n} of {of}',

  'portal.ac': 'AC',
  'portal.hp': 'HP',
  'portal.moveLeft': '{ft} ft left',
  'portal.action': 'Action',
  'portal.bonus': 'Bonus',
  'portal.actions': 'Actions',
  'portal.stand': 'Stand up',
  'portal.dash': 'Dash',
  'portal.disengage': 'Disengage',
  'portal.dodge': 'Dodge',
  'portal.disrupt': 'Disrupt the altar',
  'portal.auto': 'Auto-play this turn',
  'portal.endTurn': 'End turn',
  'portal.skip': 'Skip',

  'portal.log': 'Combat log',
  'portal.orderLabel': 'Give an order',
  'portal.orderPlaceholder': 'Give an order, like Wren to D7',
  'portal.send': 'Send',
  'portal.holdToTalk': 'Hold to talk',
  'portal.listening': 'Listening',
  'portal.heard': 'Heard:',
  'portal.dismiss': 'Dismiss',
  'portal.copyLink': 'Copy table link',
  'portal.copied': 'Link copied',
  'portal.discord': 'Use Discord voice',
  'portal.discordOff': 'Discord voice is not running right now. Try again later.',
  'portal.discordHelp': "Discord voice plays this table in the voice channel named the-portal in the WOGD Studio Discord server. Only members who registered on Atlas, our account site, can see it. Start each order with a piece's name or the word Portal: 'Wren, move to D7', 'Portal, end turn'. The microphone button works in Chrome and Edge.",
  'portal.srd': 'Uses rules from the SRD 5.2.1 by Wizards of the Coast LLC, licensed under CC BY 4.0, adapted for this game.',
  'portal.srdLink': 'Full notice in Credits',

  'portal.won': 'Victory',
  'portal.lost': 'Defeat',
  'portal.playAgain': 'Play again',
  'portal.outcome.slain': 'The Riftmaw falls, the rift gutters out, and its servants scatter into the dark.',
  'portal.outcome.sealed': 'The last seal holds. The rift snaps shut and drags the beast back through with it.',
  'portal.outcome.fallen': 'The last of the party falls, and the Riftmaw climbs out over the altar.',
  'portal.outcome.won': 'The rift is closed and the table is yours.',
  'portal.outcome.lost': 'The rite is complete and the beast is loose.',

  'portal.terrain.edge': 'Off the mat',
  'portal.terrain.open': 'Open ground',
  'portal.terrain.rubble': 'Rubble',
  'portal.terrain.pool': 'Arcane runoff',
  'portal.terrain.boulder': 'Boulder',
  'portal.terrain.pillar': 'Broken pillar',
  'portal.terrain.tree': 'Dead tree',
  'portal.terrain.altar': 'Arcane altar',
  'portal.terrain.rune': 'Rune ring',
  'portal.terrain.rift': 'The rift',
  'portal.tip.difficult': 'Difficult terrain: costs double',
  'portal.tip.half': 'Half cover',
  'portal.tip.total': 'Total cover, blocks movement',
  'portal.tip.blocks': 'Blocks movement',

  'portal.keys.title': 'Keyboard guide',
  'portal.keys.open': 'Keyboard guide',
  'portal.keys.close': 'Close',
  'portal.keys.group.turn': 'Turn',
  'portal.keys.group.actions': 'Actions',
  'portal.keys.group.board': 'Board',
  'portal.keys.group.voice': 'Voice and sharing',
  'portal.keys.group.view': 'View',
  'portal.keys.hotbar': 'Hotbar: run the buttons in the action bar, left to right',
  'portal.keys.end': 'End turn',
  'portal.keys.auto': 'Auto-play this turn',
  'portal.keys.skip': 'Skip the playback',
  'portal.keys.cancel': 'Cancel, close a window, leave the order box',
  'portal.keys.move': 'Move: show the square cursor',
  'portal.keys.attack': 'Attack: pick a target (press again for the next attack)',
  'portal.keys.dash': 'Dash',
  'portal.keys.disengage': 'Disengage',
  'portal.keys.dodge': 'Dodge',
  'portal.keys.disrupt': 'Disrupt the altar',
  'portal.keys.stand': 'Stand up',
  'portal.keys.heal': 'Heal: Second Wind or Bind wounds, then pick a friend',
  'portal.keys.up': 'Cursor up, or the previous target',
  'portal.keys.down': 'Cursor down, or the next target',
  'portal.keys.left': 'Cursor left, or the previous target',
  'portal.keys.right': 'Cursor right, or the next target',
  'portal.keys.confirm': 'Move to the cursor, strike the target, or end the turn when nothing is picked',
  'portal.keys.next': 'Next target',
  'portal.keys.prev': 'Previous target',
  'portal.keys.talk': 'Hold to talk (where speech works)',
  'portal.keys.order': 'Type an order',
  'portal.keys.copy': 'Copy the table link',
  'portal.keys.discord': 'Use Discord voice',
  'portal.keys.log': 'Show or hide the combat log',
  'portal.keys.camLeft': 'Turn the table left',
  'portal.keys.camRight': 'Turn the table right',
  'portal.keys.zoomIn': 'Zoom in',
  'portal.keys.zoomOut': 'Zoom out',
  'portal.keys.guide': 'Open this guide',
  'portal.keys.touchNote': 'On a phone or tablet, tap a square or a piece, then tap a button. Shortcuts are for a keyboard.',
  'portal.keys.tour.title': 'Playing from the keyboard',
  'portal.keys.tour.step': 'Step {n} of {of}',
  'portal.keys.tour.1.title': 'Select and move',
  'portal.keys.tour.1.body': 'Press the arrow keys to move the square cursor, then Enter to move there. You can also click a square. The cursor shows the square name, like D7, and what the move costs.',
  'portal.keys.tour.2.title': 'Act',
  'portal.keys.tour.2.body': 'Press A to attack, then Tab to pick a target and Enter to strike. D is Dash, G is Disengage, O is Dodge, H is heal, and 1 to 9 run the buttons in the bar.',
  'portal.keys.tour.3.title': 'End your turn',
  'portal.keys.tour.3.body': 'Press E to end your turn, or Enter when nothing is picked. Escape backs out of anything. P plays the turn for you.',
  'portal.keys.tour.4.title': 'Help is one key away',
  'portal.keys.tour.4.body': 'Press ? or F1 any time to see every shortcut. The keyboard button at the bottom of the screen opens it too.',
  'portal.keys.tour.next': 'Next',
  'portal.keys.tour.back': 'Back',
  'portal.keys.tour.done': 'Done',
  'portal.keys.tour.all': 'All shortcuts',
  'portal.keys.tour.never': "Don't show this again",
  'portal.keys.cursor': 'Cursor {square}',
  'portal.keys.cost': 'Move cost: {ft} ft',
  'portal.keys.noReach': 'Out of reach this turn',
  'portal.keys.pick': 'Tab or the arrow keys pick a target, Enter confirms, Escape cancels',
  'portal.keys.wait': 'Wait for the playback to finish, or press Space to skip it.',
  'portal.keys.busy': 'One moment, the table is answering.',
  'portal.keys.notYourTurn': 'It is not your turn yet.',
  'portal.keys.noAction': 'No action left this turn.',
  'portal.keys.noTargets': 'No target in reach.',
  'portal.keys.noHeal': 'Nobody to heal, or no healing left.',
  'portal.keys.noAltar': 'Stand next to the altar to disrupt it.',
  'portal.keys.noStand': 'You are not prone.',
  'portal.keys.noMove': 'No room to move there.',
  'portal.keys.noVoice': 'Speech is not available in this browser. Press T to type an order.',
  'portal.keys.noSkip': 'Nothing is playing.',
}
